<template>
  <div id="article-create-edit-form">
    <b-form @submit.prevent="onSubmitForm">
      <b-row class="article-create-edit-form">
        <b-col cols="12">
          <b-card
            no-body
            class="px-2 pb-4 mb-1 container-card"
          >
            <b-card-header>
              <span class="information-header">Information</span>
            </b-card-header>
            <b-row class="px-2">
              <b-col
                cols="12"
                md="3"
              >
                <label>{{ 'Status' }} </label>
                <b-form-checkbox
                  v-model="form.status"
                  field-value="true"
                  class="custom-control-success custom-toggle"
                  name="check-button"
                  switch
                >
                  <span class="switch-icon-left toggle-text">{{
                    'Active'
                  }}</span>
                  <span class="switch-icon-right toggle-text">{{
                    'Inactive'
                  }}</span>
                </b-form-checkbox>
              </b-col>
            </b-row>
            <b-row class="px-2 mt-1">
              <b-col
                cols="12"
                md="5"
              >
                <b-row>
                  <b-col cols="12">
                    <b-form-group
                      :label="'Article Name'"
                      label-for="article-name"
                      class="required"
                    >
                      <b-form-input
                        id="article-name"
                        v-model="form.name"
                        required
                      />
                    </b-form-group>
                  </b-col>
                  <b-col cols="12">
                    <label for="article-category">
                      Article Category
                    </label>
                    <v-select
                      v-model="form.category"
                      :searchable="false"
                      class="article-category-container bg-dropdown"
                      :class="
                        form.category ? 'article-category-selected' : null
                      "
                      :label="'category_name_th'"
                      :reduce="option => option.category_id"
                      placeholder="--Select--"
                      :options="articleCategory.payload"
                    >
                      <template #search="{ attributes, events }">
                        <input
                          class="vs__search"
                          :required="!form.category"
                          v-bind="attributes"
                          v-on="events"
                        >
                      </template>
                    </v-select>
                  </b-col>
                  <b-col
                    cols="12"
                    class="mt-1"
                  >
                    <div>
                      <label
                        for="valid-from-date"
                        class="required"
                      >
                        Valid From
                      </label>
                      <div class="d-flex">
                        <div class="p-relative mr-1 w-50">
                          <calendar-picker-icon
                            class="icon-calendar bypass"
                            :class="
                              validFrom.date ? 'date-selected-icon' : null
                            "
                          />
                          <flat-pickr
                            :id="'valid-from-date'"
                            v-model="validFrom.date"
                            class="form-control bg-date"
                            :class="validFrom.date ? 'date-selected' : null"
                            :config="flatpickrDateConfig"
                            placeholder="Start Date"
                            required
                            autocomplete="off"
                            @on-open="onOpenValidFromDatePicker"
                            @on-change="onSelectValidFromDate"
                          />
                        </div>
                        <div class="p-relative w-50">
                          <clock-picker-icon
                            class="icon-calendar date-picker-icon bypass"
                            :class="
                              validFrom.time ? 'date-selected-icon' : null
                            "
                          />
                          <flat-pickr
                            id="valid-from-time"
                            v-model="validFrom.time"
                            class="form-control bg-date"
                            :class="validFrom.time ? 'date-selected' : null"
                            :config="flatpickrTimeConfig"
                            :placeholder="'HH : mm'"
                            required
                            autocomplete="off"
                            @on-open="onOpenValidFromTimePicker"
                            @on-change="onSelectValidFromTimePicker"
                          />
                        </div>
                      </div>
                    </div>
                  </b-col>
                  <b-col
                    cols="12"
                    class="mt-1"
                  >
                    <label
                      for="valid-from-to"
                      class="required"
                    >
                      Valid Through
                    </label>
                    <div class="d-flex">
                      <div class="p-relative mr-1 w-50">
                        <calendar-picker-icon
                          class="icon-calendar bypass"
                          :class="
                            validThrough.date ? 'date-selected-icon' : null
                          "
                        />
                        <flat-pickr
                          :id="'valid-to-date'"
                          v-model="validThrough.date"
                          class="form-control bg-date"
                          :class="validThrough.date ? 'date-selected' : null"
                          :config="flatpickrDateConfig"
                          placeholder="End Date"
                          autocomplete="off"
                          required
                        />
                      </div>
                      <div class="p-relative w-50">
                        <clock-picker-icon
                          class="icon-calendar date-picker-icon bypass"
                          :class="
                            validThrough.time ? 'date-selected-icon' : null
                          "
                        />
                        <flat-pickr
                          id="valid-from-time"
                          v-model="validThrough.time"
                          class="form-control bg-date"
                          :class="validThrough.time ? 'date-selected' : null"
                          :config="flatpickrTimeConfig"
                          :placeholder="'HH : mm'"
                          autocomplete="off"
                          required
                          @on-open="onOpenValidThroughTimePicker"
                        />
                      </div>
                    </div>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
            <b-row class="px-2 mt-1">
              <b-col cols="12">
                <b-row>
                  <b-col cols="12">
                    <div>
                      <label>{{ 'Content Video' }} </label>
                      <div class="d-flex align-items-center">
                        <feather-icon
                          icon="CircleIcon"
                          class="mr-1"
                          :class="resolveStatusClass(form.isVideo)"
                        />

                        <span class="font-medium-5">{{
                          resolveStatusLabel(form.isVideo)
                        }}</span>
                      </div>
                    </div>
                  </b-col>
                </b-row>
                <b-row class="m-auto h-auto w-100">
                  <div class="col-12 pr-0 pl-0 mt-1">
                    <div class="h-100 pb-1">
                      <label
                        class="font-medium-5 required custom-tab-label"
                      >Article Detail</label>
                      <b-tabs class="custom-tab">
                        <b-tab
                          :title="'Thai'"
                          title-link-class="font-medium-5"
                          lazy
                        >
                          <custom-quill-editor
                            v-model="form.detail"
                            class="custom-quill-editor h-100"
                            :options="editorOption"
                          >
                            <div
                              id="toolbar"
                              slot="toolbar"
                            >
                              <custom-tool-bar />
                              <b-dropdown
                                dropright
                                no-caret
                                variant="none"
                              >
                                <template #button-content>
                                  <feather-icon
                                    icon="FilmIcon"
                                    size="14"
                                    color="black"
                                  />
                                </template>
                                <div
                                  style="width: 500px"
                                  class="d-flex mx-1"
                                >
                                  <b-form-input
                                    v-model="form.videoTag"
                                    autocomplete="off"
                                  />
                                  <button
                                    type="button"
                                    style="width: auto"
                                    class="ml-2 add-video-tag-button"
                                    variant="success"
                                    @click="onChangeVideoTag(form.videoTag)"
                                  >
                                    {{ 'Save' }}
                                  </button>
                                </div>
                              </b-dropdown>
                            </div>
                          </custom-quill-editor>
                        </b-tab>
                        <b-tab
                          :title="'English'"
                          title-link-class="font-medium-5"
                          lazy
                        >
                          <custom-quill-editor
                            ref="testQuill"
                            v-model="form.detailEn"
                            class="custom-quill-editor flex-stretch h-100"
                            :options="editorOption"
                          >
                            <div
                              id="toolbar"
                              slot="toolbar"
                            >
                              <custom-tool-bar />
                              <b-dropdown
                                dropright
                                no-caret
                                variant="none"
                              >
                                <template #button-content>
                                  <feather-icon
                                    icon="FilmIcon"
                                    size="14"
                                    color="black"
                                  />
                                </template>
                                <div
                                  style="width: 500px"
                                  class="d-flex mx-1"
                                >
                                  <b-form-input
                                    v-model="form.videoTag"
                                    autocomplete="off"
                                  />
                                  <button
                                    type="button"
                                    style="width: auto"
                                    class="ml-2 add-video-tag-button"
                                    variant="success"
                                    @click="onChangeVideoTagEn(form.videoTag)"
                                  >
                                    {{ 'Save' }}
                                  </button>
                                </div>
                              </b-dropdown>
                            </div>
                          </custom-quill-editor>
                        </b-tab>
                      </b-tabs>
                    </div>
                  </div>
                </b-row>
                <b-row class="w-100">
                  <b-col cols="12">
                    <b-form-group
                      :label="'Remark'"
                      label-for="article-remark"
                    >
                      <b-form-input
                        id="article-remark"
                        v-model="form.remark"
                      />
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row class="w-100">
                  <b-col cols="12">
                    <b-form-group
                      :label="'Reference 1'"
                      label-for="article-reference1"
                    >
                      <b-form-input
                        id="article-reference1"
                        v-model="form.reference1"
                      />
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row class="w-100">
                  <b-col cols="12">
                    <b-form-group
                      :label="'Reference 2'"
                      label-for="article-reference2"
                    >
                      <b-form-input
                        id="article-reference2"
                        v-model="form.reference2"
                      />
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row class="w-100">
                  <b-col cols="12">
                    <b-form-group
                      :label="'Reference 3'"
                      label-for="article-reference3"
                    >
                      <b-form-input
                        id="article-reference3"
                        v-model="form.reference3"
                      />
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row class="w-100">
                  <b-col cols="12">
                    <b-form-group
                      :label="'Reference 4'"
                      label-for="article-reference4"
                    >
                      <b-form-input
                        id="article-reference4"
                        v-model="form.reference4"
                      />
                    </b-form-group>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </b-card>
          <b-card
            no-body
            class="px-2 pb-4 mb-1 container-card"
          >
            <b-card-header>
              <label class="information-header">Cover Image</label>
            </b-card-header>
            <b-row class="px-2">
              <b-col
                cols="6"
                md="6"
              >
                <label
                  for="image1"
                  class="required"
                > Cover Image </label>
                <image-uploader
                  :image-url="form.image_1.url"
                  @onUpload="onUploadCoverImage"
                />
              </b-col>
              <b-col
                cols="6"
                md="6"
              >
                <label
                  for="iamge2"
                  class="required"
                > Square Image </label>
                <image-uploader
                  :image-url="form.image_2.url"
                  @onUpload="onUploadSquareImage"
                />
              </b-col>
            </b-row>
          </b-card>
          <!-- <b-card no-body class="px-2 pb-4 mb-1 container-card">
            <b-card-header>
              <span class="information-header">{{ "Tiers" }}</span>
            </b-card-header>
            <b-col cols="12" lg="6" class="px-2">
              <label for="flag-option">
                <span>{{ "Tiers" }}</span>
              </label>
              <v-select
                multiple
                :options="tierFlagOptions"
                :label="'tier_name_th'"
                class="tag-dropdown"
                id="flag-option"
                v-model="form.tierFlag"
                :disabled="isEdit"
              />
            </b-col>
          </b-card> -->
          <b-card
            no-body
            class="px-2 pb-4 mb-1 container-card"
          >
            <b-card-header>
              <span class="information-header">Reward Management</span>
            </b-card-header>
            <b-row class="px-4">
              <b-col
                cols="12"
                class="mb-1"
              >
                <label for="reward-type"> Reward Type </label>
                <b-form-radio-group
                  v-model="form.previlege_type_id"
                  :options="rewardTypeOptions"
                  stacked
                  class="custom-checkbox-group"
                  required
                  :disabled="isEdit"
                  @change="onChangeCondition"
                />
              </b-col>
              <!-- <b-col cols="12" class="mb-1" v-if="form.previlege_type_id !== 3">
                <label for="reward-condition"> Reward Condition </label>
                <b-form-radio-group
                  :options="
                    form.previlege_type_id == 2
                      ? pointConditionOptions
                      : rewardConditionOptions
                  "
                  :style="renderCheckUrl"
                  :disabled="form.previlege_type_id == 3 || isEdit"
                  stacked
                  class="article-radio-group"
                  @change="onChangeCondition"
                  required
                  v-model="form.condition"
                />
              </b-col> -->
            </b-row>
          </b-card>
          <b-card
            v-if="form.previlege_type_id == 2 && form.condition == 1"
            no-body
            class="px-2 pb-4 mb-1 container-card"
          >
            <b-card-header>
              <span class="information-header">Reward Setting</span>
            </b-card-header>
            <b-row class="px-2">
              <b-col
                cols="12"
                class="d-flex align-items-center flex-wrap"
              >
                <b-form-input
                  id="point"
                  v-model="form.pointAlltier"
                  autocomplete="off"
                  type="number"
                  class="article-point-container"
                  :disabled="isEdit"
                  required
                />
                <span class="ml-3 required">{{ 'Point' }}</span>
              </b-col>
            </b-row>
          </b-card>
          <b-card
            v-if="form.previlege_type_id == 1 && form.condition == 1"
            no-body
            class="px-2 pb-4 mb-1 container-card"
          >
            <b-card-header>
              <span class="information-header">Reward Setting</span>
            </b-card-header>
            <b-row class="px-2">
              <b-col
                cols="12"
                class="d-flex align-items-center flex-wrap"
              >
                <span class="input-text-point">{{ 'Inventory' }}</span>
                <v-select
                  v-model="form.inventoryRef"
                  :searchable="false"
                  class="article-reward-container bg-dropdown"
                  :class="form.inventoryRef ? 'article-category-selected' : null"
                  :label="'name'"
                  placeholder="--Select--"
                  required
                  :options="rewardSettingOption.inventory"
                  :disabled="isEdit"
                  @input="onSelectInventory"
                />
              </b-col>
              <b-col
                cols="12"
                class="d-flex align-items-center flex-wrap mt-2"
              >
                <span class="input-text-point">{{ 'Reward' }}</span>
                <v-select
                  v-model="form.rewardAlltier"
                  :searchable="false"
                  class="article-reward-container bg-dropdown"
                  :class="
                    form.rewardAlltier ? 'article-category-selected' : null
                  "
                  placeholder="--Select--"
                  :label="isEdit ? 'reward_name_th' : 'name_th'"
                  required
                  :reduce="option => option"
                  :options="rewardSettingOption.all"
                  :disabled="!form.inventoryRef || isEdit"
                  @input="renderRewardTable(form.rewardAlltier)"
                />
              </b-col>
              <b-col
                v-if="form.inventoryRef"
                cols="12"
                class="mt-5 mb-1"
              >
                <b-table
                  :fields="fieldsRewardTable"
                  :items="form.table"
                  responsive
                  bordered
                  borderless
                  sticky-header
                  no-local-sorting
                  class="article-reward-table"
                >
                  <template #cell(seq)="data">
                    <span>{{ data.index + 1 }}</span>
                  </template>
                  <template #cell(banner)="data">
                    <div
                      v-if="data.item.banner"
                      class="col-img"
                    >
                      <img
                        class="h-100"
                        :src="data.item.banner"
                        alt=""
                        draggable="false"
                      >
                    </div>
                    <div v-else>
                      -
                    </div>
                  </template>
                  <template
                    v-if="isEdit"
                    #cell(banner_url)="data"
                  >
                    <div
                      v-if="data.item.banner_url"
                      class="col-img"
                    >
                      <img
                        class="h-100"
                        :src="data.item.banner_url"
                        alt=""
                        draggable="false"
                      >
                    </div>
                    <div v-else>
                      -
                    </div>
                  </template>
                </b-table>
              </b-col>
            </b-row>
          </b-card>
        </b-col>
      </b-row>
      <b-col
        cols="12"
        class="d-flex justify-content-center flex-wrap mt-1"
      >
        <cancel-button
          class="mr-1"
          @click.native="$router.push('/article/article/list')"
        />
        <save-button
          :type="'submit'"
          :loading="loading.createOrEdit"
        />
      </b-col>
    </b-form>
  </div>
</template>

<script>
import {
  onBeforeMount,
  reactive,
  ref,
  watch,
  computed,
  onUpdated,
  getCurrentInstance,
  onMounted,
} from '@vue/composition-api'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import {
  BForm,
  BCard,
  BRow,
  BCol,
  BCardHeader,
  BFormRadioGroup,
  BFormInput,
  BFormGroup,
  BFormCheckbox,
  BFormTextarea,
  BTable,
  BSpinner,
  BButton,
  BDropdown,
} from 'bootstrap-vue'
import { quillEditor } from 'vue-quill-editor'
import flatPickr from 'vue-flatpickr-component'
import vSelect from 'vue-select'
import CalendarPickerIcon from '@/@core/components/svg/common/CalendarPicker.vue'
import ClockPickerIcon from '@/@core/components/svg/common/ClockPicker.vue'
import ImageUploader from '@core/components/image-uploader/ImageUploader.vue'
import SaveButton from '@/views/components/button/SaveButton.vue'
import CancelButton from '@/views/components/button/CancelButton.vue'
import CustomToolBar from './CustomToolBar.vue'

import useArticleCreateEditForm from '../hooks/useArticleCreateEditForm'

export default {
  components: {
    BForm,
    BCard,
    BRow,
    BCol,
    BCardHeader,
    BFormRadioGroup,
    BFormInput,
    BFormGroup,
    BFormCheckbox,
    BFormTextarea,
    BTable,
    BSpinner,
    BButton,
    BDropdown,
    flatPickr,
    vSelect,
    CalendarPickerIcon,
    ClockPickerIcon,
    ImageUploader,
    SaveButton,
    CancelButton,
    quillEditor,
    CustomToolBar,
  },
  props: {
    isEdit: { type: Boolean, default: false },
  },
  data: () => ({
    editorOption: {
      modules: {
        toolbar: '#toolbar',
      },
      theme: 'snow',
    },
  }),
  setup(props) {
    const {
      keyChange,
      loading,
      form,
      flatpickrDateConfig,
      flatpickrTimeConfig,
      validFrom,
      validThrough,
      rewardTypeOptions,
      pointConditionOptions,
      rewardConditionOptions,
      rewardSettingOption,
      articleCategory,
      fieldsRewardTable,
      onChangeCondition,
      renderRewardTable,
      onSelectInventory,
      onUploadCoverImage,
      onUploadSquareImage,
      onOpenValidFromDatePicker,
      onOpenValidFromTimePicker,
      onSelectValidFromDate,
      onSelectValidFromTimePicker,
      onOpenValidThroughTimePicker,
      onSubmitForm,
      onChangeVideoTag,
      resolveStatusClass,
      resolveStatusLabel,
    } = useArticleCreateEditForm(props)

    const vm = getCurrentInstance().proxy

    const editor = computed(() => vm)

    onMounted(() => {
      console.log('this is current quill instance object', editor)
    })
    return {
      keyChange,
      loading,
      form,
      flatpickrDateConfig,
      flatpickrTimeConfig,
      validFrom,
      validThrough,
      rewardTypeOptions,
      pointConditionOptions,
      rewardConditionOptions,
      rewardSettingOption,
      articleCategory,
      fieldsRewardTable,
      onChangeCondition,
      renderRewardTable,
      onSelectInventory,
      onUploadCoverImage,
      onUploadSquareImage,
      onOpenValidFromDatePicker,
      onOpenValidFromTimePicker,
      onSelectValidFromDate,
      onSelectValidFromTimePicker,
      onOpenValidThroughTimePicker,
      onSubmitForm,
      onChangeVideoTag,
      resolveStatusClass,
      resolveStatusLabel,
    }
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>

<style scoped>
@import '~@/assets/css/override-styles/status.css';
@import '~@/assets/css/override-styles/dynamic-fields.css';
@import '~@/assets/css/pages/data-management.css';
@import '~@/assets/css/override-styles/tag-dropdown.css';
@import '~@/assets/css/pages/article/create-article.css';
@import '~@/assets/css/override-styles/progress-nav.css';
</style>
